{
  "FormEngineJwtDatasource": {
    "title": "JWT-Daten",
    "description": "Lesen Sie Daten aus einem bestimmten JSON-Web-Token"
  },
  "mask": {
    "FormEngineJwtDatasource": {
      "description": "Beschreibung",
      "jwtSource": "Token-Quelle",
      "jwtOutput": "Ausgabename"
    }
  }
}